import React from 'react';

type Props = {
  onClick: () => void;
  type?: string;
  name: string;
  description?: string;
  thumbnail: string;
};

const AssetCard: React.FC<Props> = ({
  onClick,
  type,
  name,
  description,
  thumbnail,
}) => {
  return (
    <div
      className='flex-1 cursor-pointer rounded-xl bg-linear-dark p-[1px]'
      onClick={onClick}
    >
      <div className='relative overflow-hidden rounded-xl'>
        {type && (
          <span
            className={`
              absolute left-1 top-1 w-fit truncate whitespace-nowrap rounded border
              border-neon-green bg-radial-border px-2 py-1 text-xs font-medium text-white
              shadow-inset-combo
            `}
          >
            {`${type.slice(0, 1).toUpperCase()}${type.slice(1)}`}
          </span>
        )}

        <img
          className='h-[214px] w-full object-cover'
          src={thumbnail}
          alt='asset'
        />

        <div className='absolute inset-0 bg-black_gradient' />

        <div className='absolute bottom-0 left-0 right-0 p-2'>
          <p className='text-sm font-medium text-white'>{name}</p>

          <div className='truncate whitespace-nowrap text-sm text-teal-2'>
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetCard;
